import React from "react";
import {
  BarrasSimple,
  ResultProvider,
  TYPES
} from "@atresmedia/elections_modules_library";
import { CintilloText } from "../../components/cintillo/text";
import cintillos from "../../components/cintillo/cintillos";
import "./sumaBloques.scss";

export default ({ match }) => {
  const [selectedIds, setSelectedIds] = React.useState([18, 25, 7]);
  const { year, type, electionNumber, placesIds, community } = match.params;
  const currentCintillo = rightSide => {
    let Cintillo = cintillos[community];
    return Cintillo && <Cintillo rightSide={rightSide}></Cintillo>;
  };

  // Con esta funcion obtenemos ciertos valores pàra los partidos seleccionados y los que no.
  // Estos parametros son: text=(cadena a mostrar con todos los partidos separados por '+')
  //                      seats=(escaños totales de los partidos)
  //                      parties=(items de cada partido con todos los datos)

  const getSeatsAndAcronyms = data => {
    const initialValue = {
      included: { text: "", seats: 0, parties: [] },
      excluded: { text: "", seats: 0, parties: [] }
    };
    if (data) {
      return data.reduce((acc, party) => {
        if (party.seats > 0) {
          //Seleccionamos el campo que vamos a modificar
          let field = selectedIds.includes(party.id) ? "included" : "excluded";
          //Acumulamos tanto texto como seats como los parties
          acc[field].text = acc[field].text.length
            ? `${acc[field].text} + ${party.partyAcronym}`
            : party.partyAcronym;
          acc[field].seats += party.seats;
          acc[field].parties = [...acc[field].parties, party];
        }
        return acc;
      }, initialValue);
    } else {
      return initialValue;
    }
  };
  return (
    <div className="SCSumaBloquesDato">
      <ResultProvider
        active={true}
        year={year}
        type={type}
        placeId={type === TYPES.REGIONAL ? community : placesIds} // IMPORTANTE --> modificar parametros del resultProvider para que busque resultados por comunidad
        electionPlace={type === TYPES.REGIONAL ? community : placesIds}
        electionNumber={electionNumber}
      >
        {generalData => {
          const { included, excluded } = getSeatsAndAcronyms(
            generalData.partiesResult
          );

          return (
            <div className="SCSumaBloquesMain">
              <div className="SCSumaBloquesSection">
                {currentCintillo(<CintilloText>SUMA DE BLOQUES</CintilloText>)}
                <BarrasSimple
                  data={[...included.parties, ...excluded.parties]}
                  selecteds={
                    selectedIds.length > 0
                      ? [...selectedIds, ...excluded.parties.map(e => e.id)]
                      : []
                  }
                  totalSeat={generalData.totalSeats}
                  centerProps={{ position: "down", lineStyle: "solid" }}
                  title={
                    selectedIds.length > 0 && (
                      <div className="SCSumaBloquesDatos">
                        <div className="SCSumaBloquesDato">
                          <p className="big">{included.seats}</p>
                          <p>{included.text}</p>
                        </div>
                        <div className="SCSumaBloquesDato right">
                          <p className="big">{excluded.seats}</p>
                          <p>{excluded.text}</p>
                        </div>{" "}
                      </div>
                    )
                  }
                />
              </div>
            </div>
          );
        }}
      </ResultProvider>
    </div>
  );
};
